<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">
            {{ $t('reports.delivery_report_title') }}
          </h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>
      <v-speed-dial
        key="1"
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-btn color="gradiente" dark fab>
            <v-icon>more_vert</v-icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadPdf"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>{{ $t('reports.shared.download_pdf') }}</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXLSX"
          >
            <v-img
              :style="{ flex: '0 1 auto' }"
              height="28px"
              width="28px"
              :src="require('@/assets/reports/IconoCSV.png')"
            />
          </v-btn>
          <span>{{ $t('reports.shared.download_xlsx') }}</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="showSettingModal"
          >
            <v-icon>settings</v-icon>
          </v-btn>
          <span>Ajuste de reportes</span>
        </v-tooltip>
      </v-speed-dial>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 120px !important;
      "
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-menu
                    solo
                    flat
                    hide-details
                    :close-on-content-click="false"
                    :nudge-left="500"
                    :nudge-width="500"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :label="$t('reports.shared.search')"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        @click:append-outer="getEntries"
                        @click:clear="
                          () => {
                            search = ''
                            getEntries()
                          }
                        "
                        @keyup.enter="getEntries"
                        v-model="search"
                      >
                        <template v-slot:append>
                          <v-icon v-on="on">tune</v-icon>
                        </template>
                      </v-text-field>
                      <v-btn
                        class="mx-0 my-1"
                        color="grey"
                        dark
                        @click="reportDelivers"
                        style="width: 100%"
                      >
                        <v-icon> insights </v-icon>
                        {{ $t('reports.delivery_report.graphics') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <!-- Level -->
                          <v-flex xs12 sm6 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :label="$t('reports.delivery_report.level')"
                                  flat
                                  solo
                                  hide-details
                                  return-object
                                  item-value="levelId"
                                  item-text="levelName"
                                  :items="levels"
                                  v-model="filters.levelIds"
                                  clearable
                                  @change="
                                    () => {
                                      filterLevel()
                                      getEntries()
                                    }
                                  "
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- grade group -->
                          <v-flex xs12 sm6 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  item-value="groupId"
                                  item-text="groupName"
                                  :label="$t('reports.delivery_report.group')"
                                  flat
                                  solo
                                  hide-details
                                  no-data-text="No hay grupos"
                                  return-object
                                  :items="grades"
                                  v-model="filters.gradeGroupIds"
                                  clearable
                                  @change="getEntries"
                                  @click:clear="getEntries"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- requests -->
                          <v-flex xs12 sm6 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  item-value="value"
                                  item-text="text"
                                  label="Tipo de solicitud"
                                  flat
                                  solo
                                  hide-details
                                  no-data-text="No hay tipos de solicitud"
                                  clearable
                                  :items="requestType"
                                  return-object
                                  v-model="filters.requestType"
                                  @change="getEntries"
                                  @click:clear="getEntries"
                                >
                                  <template
                                    v-slot:selection="{ item, index }"
                                    v-if="
                                      requestType.length ===
                                      filters.requestType.length
                                    "
                                  >
                                    <span
                                      v-if="
                                        requestType.length ===
                                          filters.requestType.length &&
                                        index === requestType.length - 1
                                      "
                                    >
                                      {{ $t('reports.delivery_report.all') }}
                                    </span>
                                  </template>
                                  <template v-slot:prepend-item>
                                    <v-list-tile ripple @click="toggle">
                                      <v-list-tile-action>
                                        <v-icon
                                          :color="
                                            filters.requestType.length > 0
                                              ? 'red'
                                              : ''
                                          "
                                        >
                                          {{ icon }}
                                        </v-icon>
                                      </v-list-tile-action>
                                      <v-list-tile-content>
                                        <v-list-tile-title>
                                          {{
                                            $t('reports.delivery_report.all')
                                          }}
                                        </v-list-tile-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider class="mt-2"></v-divider>
                                  </template>
                                </v-select>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- Initial date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>
                                  {{ $t('reports.delivery_report.start_date') }}
                                </v-flex>
                                <v-flex xs7 sm8 pl-0 ml>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="momentFormatFirst"
                                        :label="
                                          $t(
                                            'reports.delivery_report.start_date'
                                          )
                                        "
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      v-model="timeFirst"
                                      :min="limitFirstDate"
                                      :max="today"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <!-- final date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>
                                  {{ $t('reports.delivery_report.end_date') }}
                                </v-flex>
                                <v-flex xs7 sm8 pl-0>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        id="last-small"
                                        :value="momentFormatLast"
                                        :label="
                                          $t('reports.delivery_report.end_date')
                                        "
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                        solo
                                        flat
                                        hide-details
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      v-model="timeLast"
                                      :min="timeFirst"
                                      :max="today"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions
                        style="justify-content: end; margin-right: 8px"
                      >
                        <v-flex
                          xd12
                          sm7
                          md4
                          style="display: flex; justify-content: end"
                        >
                          <v-btn
                            @click="filterClear"
                            v-show="showFilter"
                            color="primary"
                          >
                            <v-icon left>close</v-icon>
                            {{ $t('reports.shared.clear_filters') }}
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :headers="headers"
                :rows-per-page-items="[25, 50, 100]"
                :items="entries"
                :loading="working.wEntries"
                :pagination.sync="pagination"
                item-key="id"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                class="delivery-table"
                must-sort
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :style="header.style"
                      :class="[
                        header.sortable ? 'sortable_pick' : '',
                        'text-xs-left',
                      ]"
                      @click="header.sortable ? changeSort(header.value) : null"
                    >
                      {{ $t(header.langKey) }}
                      <SortTableArrow
                        :hide="header.sortable === false"
                        :is-active="header.value === pagination.sortBy"
                        :is-upward="pagination.descending"
                      />
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <!-- Nueva entrada con el socket -->
                  <tr :class="props.item.isNew ? 'new-entry' : ''">
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 110px; min-width: 110px"
                    >
                      <CustomTooltipOverflowText>
                        {{ props.item.level }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 120px; max-width: 100px; min-width: 100px"
                    >
                      <CustomTooltipOverflowText>
                        {{ props.item.grade }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      <CustomTooltipOverflowText>
                        {{ props.item.firstName }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      <CustomTooltipOverflowText>
                        {{ props.item.lastName }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 210px; max-width: 150px; min-width: 150px"
                    >
                      {{ props.item.personId }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 210px; max-width: 175px; min-width: 175px"
                    >
                      <!-- Solicitado -->
                      {{ props.item.requestedTime }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 210px; max-width: 175px; min-width: 175px"
                    >
                      <!-- Camino -->
                      {{ props.item.calledTime || '-' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 210px; max-width: 175px; min-width: 175px"
                    >
                      <!-- Entregado -->
                      {{ props.item.deliveryTime }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 210px; max-width: 175px; min-width: 175px"
                    >
                      <!-- cancelado -->
                      {{ props.item.cancelledTime || '-' }}
                    </td>
                    <td
                      class="text-xs-center"
                      style="width: 210px; max-width: 135px; min-width: 135px"
                      @click="expandDelivery(props)"
                    >
                      <v-btn icon>
                        <v-icon class="no-border">{{ 'info_outline' }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <StudentDelivery
                    v-if="expandables.Delivery"
                    :parentName="props.item.parentName"
                    :parentLastName="props.item.parentLastName || 'N/A '"
                    :door="props.item.door"
                    :carModel="props.item.carModel || 'Caminando'"
                    :carColor="props.item.carColor || ''"
                    :plates="props.item.plates || ''"
                    :typeUser="props.item.typeReq"
                    :device="props.item.refEntity"
                    :whoDelivered="props.item.whoDelivered"
                    :whoCancelled="props.item.whoCancelled"
                  ></StudentDelivery>
                </template>
                <!-- Paginación -->
                <template v-slot:pageText="props">
                  {{ props.pageStart }} - {{ props.pageStop }} de
                  {{ props.itemsLength }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <ReportSettings
        :show="showSetting"
        title="Configuración de reporte de entregas"
        reportSettingtype="STUDENT_DELIVERY"
        @closeEditSetting="onCloseEditSetting"
      />
      <loading v-model="working.wLoading" text="Trabajando" />
      <success v-model="toast.success" text="Operación exitosa" />
      <error v-model="toast.failed" text="Ups ocurrió un error" />
      <error
        v-model="toast.downloadFile"
        :time="5000"
        text="No hay registros para la fecha seleccionada, elige un rango que sí cuente con registros"
      />

      <DeliverReports
        v-on:close="closeDelivers"
        v-model="modals.delivers.show"
        :value="modals.delivers.show"
        :body="modals.delivers.body"
      ></DeliverReports>
    </v-container>
  </div>
</template>

<script>
import { funciones } from '../../../../Mixins/Funciones'

import moment from 'moment'
import JsonCSV from 'vue-json-csv'
import JsonXSL from 'vue-json-excel'
import { mapGetters } from 'vuex'
import error from '../../../Dialogs/Error.vue'
import loading from '../../../Dialogs/Loading.vue'
import success from '../../../Dialogs/Success.vue'
import DeliverReports from '../../../Modals/DeliverReportsModal.vue'
import ReportSettings from '../../../Modals/reportSettings/reportSettings.vue'
import StudentDelivery from '../../../Sections/Students/Student-delivery.vue'

import {
  _downloadFileFromContentDisposition,
  _isSomeDifferent,
} from '../../../../utils/genericUtils.js'
import SortTableArrow from '../../../Tools/SortTableArrow.vue'
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'
import {
  filterByLevel,
  isNotEmpty,
  parseGroups,
  parseLevels,
} from '../utils.js'

export default {
  components: {
    loading,
    success,
    error,
    StudentDelivery,
    JsonCSV,
    JsonXSL,
    DeliverReports,
    SortTableArrow,
    ReportSettings,
    CustomTooltipOverflowText,
  },
  mixins: [funciones],

  data: () => ({
    showFilter: false,
    initialStateParams: [],
    posibleFilters: { gradeGroups: [], levels: [] },
    togg: false,
    expandables: {
      Delivery: false,
      isOculto: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    colapSel: null,
    pagination: {
      sortBy: 'NAME',
      descending: false,
    },
    filters: {
      search: '',
      gradeGroupIds: '',
      levelIds: '',
      requestType: [
        { text: 'Tutor', value: 'PAR' },
        { text: 'Tercero', value: 'QRT' },
        { text: 'Staff', value: 'EMP' },
        { text: 'Pase de salida', value: 'EXT' },
        { text: 'Transporte', value: 'STR' },
      ],
    },
    modalF: false,
    modalL: false,
    modalF1: false,
    modalL: false,
    timeFirst: moment().format('YYYY-MM-DD'),
    timeLast: moment().format('YYYY-MM-DD'),
    entries: [],
    grades: [],
    requestType: [
      { text: 'Tutor', value: 'PAR' },
      { text: 'Tercero', value: 'QRT' },
      { text: 'Staff', value: 'EMP' },
      { text: 'Pase de salida', value: 'EXT' },
      { text: 'Transporte', value: 'STR' },
    ],
    levels: [],
    delivers: [],
    json_data: [],

    labels: {
      level: 'Nivel',
      grade: 'Grupo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      personId: 'Matrícula',
      createdAt: 'Fecha/Hora Solicitado',
      calledTime: 'Fecha/Hora Camino',
      deliveryTime: 'Fecha/Hora Entregado',
      parentName: 'Nombre Solicitante',
      parentLastName: 'Apellido Solicitante',
      typeReq: 'Usuario',
      door: 'Puerta',
      carModel: 'Auto',
      carColor: 'Color',
      plates: 'Placas',
    },
    fields: [
      'level',
      'grade',
      'firstName',
      'lastName',
      'personId',
      'createdAt',
      'calledTime',
      'deliveryTime',
      'parentName',
      'parentLastName',
      'typeReq',
      'door',
      'carModel',
      'carColor',
      'plates',
    ],
    search: '',
    gradeGroup: [],
    level: [],

    toast: {
      success: false,
      failed: false,
      downloadFile: false,
    },
    working: {
      wEntries: false,
      wLoading: false,
    },
    headers: [
      {
        text: 'Nivel',
        align: 'left',
        value: 'LEVEL',
        sortable: true,
        style: 'width: 200px; max-width: 110px; min-width: 110px',
        langKey: 'reports.delivery_report.level',
      },
      {
        text: 'Grupo',
        align: 'left',
        value: 'grade',
        sortable: false,
        style: 'width: 120px; max-width: 100px; min-width: 100px',
        langKey: 'reports.delivery_report.group',
      },
      {
        text: 'Nombres',
        align: 'left',
        value: 'NAME',
        sortable: true,
        style: 'width: 200px; max-width: 200px; min-width: 200px',
        langKey: 'reports.delivery_report.first_name',
      },
      {
        text: 'Apellido',
        align: 'left',
        value: 'LAST_NAME',
        sortable: true,
        style: 'width: 200px; max-width: 200px; min-width: 200px',
        langKey: 'reports.delivery_report.last_name',
      },
      {
        text: 'Matrícula',
        align: 'left',
        value: 'ID',
        sortable: false,
        style: 'width: 210px; max-width: 150px; min-width: 150px',
        langKey: 'reports.delivery_report.enrollment',
      },
      {
        text: 'Solicitado',
        value: 'REQUESTED',
        align: 'left',
        sortable: true,
        style: 'width: 210px; max-width: 175px; min-width: 175px',
        langKey: 'reports.delivery_report.requested',
      },
      {
        text: 'EnCamino',
        value: 'CALLED',
        align: 'left',
        sortable: true,
        style: 'width: 210px; max-width: 175px; min-width: 175px',
        langKey: 'reports.delivery_report.called',
      },
      {
        text: 'Entregado',
        value: 'DELIVERED',
        align: 'left',
        sortable: true,
        style: 'width: 210px; max-width: 175px; min-width: 175px',
        langKey: 'reports.delivery_report.delivered',
      },
      {
        text: 'Cancelado',
        value: 'CANCELLED',
        align: 'left',
        sortable: true,
        style: 'width: 210px; max-width: 175px; min-width: 175px',
        langKey: 'reports.delivery_report.cancelled',
      },
      {
        text: 'Mas información',
        value: '',
        align: 'left',
        sortable: false,
        style: 'width: 210px; max-width: 135px; min-width: 135px',
        langKey: 'reports.delivery_report.more_info',
      },
    ],
    modals: {
      events: false,
      delivers: {
        show: false,
        body: {},
      },
    },
    connected: false,
    today: new Date().toLocaleDateString('sv-SE'),
    showSetting: false,
  }),
  filters: {},
  methods: {
    onCloseEditSetting() {
      this.showSetting = false
    },
    showSettingModal() {
      this.showSetting = true
    },
    reportDelivers() {
      let firstMoment = moment(this.timeFirst, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjB = firstMoment.toDate()
      var monthB = dateObjB.getMonth() + 1 //months from 1-12
      var dayB = dateObjB.getDate()
      var yearB = dateObjB.getFullYear()

      let lastMoment = moment(this.timeLast, 'YYYY-MM-DD')
        .hour(0)
        .minute(0)
        .second(0)
      var dateObjE = lastMoment.toDate()
      var monthE = dateObjE.getMonth() + 1 //months from 1-12
      var dayE = dateObjE.getDate()
      var yearE = dateObjE.getFullYear()
      var body = {
        yearB: yearB.toString(),
        monthB: monthB.toString(),
        dayB: dayB.toString(),
        yearE: yearE.toString(),
        monthE: monthE.toString(),
        dayE: dayE.toString(),
      }
      this.modals.delivers.body = body
      this.modals.delivers.show = true
    },
    closeDelivers(val) {
      this.modals.delivers.show = val
      this.modals.delivers.body = {}
    },
    expandDelivery(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          Delivery: false,
          isOculto: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.Delivery) {
        props.expanded = !props.expanded
        this.expandables = {
          Delivery: false,
          isOculto: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.Delivery) {
        props.expanded = !props.expanded

        this.expandables = {
          Delivery: true,
          isOculto: false,
        }
      } else if (props.expanded && !this.expandables.Delivery) {
        this.expandables = {
          Delivery: true,
          isOculto: false,
        }
      }
    },
    filterSearch(clean) {
      if (clean) {
        this.filters.search = ''
      } else {
        this.filters.search = this.search ? this.search : ''
      }

      if (!this.working.wLoading) {
        this.getEntries()
      }
    },
    getParms() {
      const params = {
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        from: this.timeFirst ? this.timeFirst : undefined,
        to: this.timeLast ? this.timeLast : undefined,
        levelIds: isNotEmpty(this.filters.levelIds)
          ? this.filters.levelIds.map((e) => e.levelId)
          : undefined,
        gradeGroupIds: isNotEmpty(this.filters.gradeGroupIds)
          ? this.filters.gradeGroupIds.map((e) => e.groupId)
          : undefined,
        search: this.filters.search ? this.filters.search : undefined,
      }

      if (isNotEmpty(this.filters.requestType)) {
        if (!(this.requestType.length === this.filters.requestType.length)) {
          params.requestType = this.filters.requestType.map((e) => e.value)
        }
      }
      return params
    },
    downloadPdf() {
      const params = this.getParms()
      this.working.wLoading = true
      this.$store
        .dispatch('reports/getStudentsOutingsPdf', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((e) => {
          console.log(e)
          this.toast.failed = true
        })
        .finally(() => {
          this.working.wLoading = false
        })
    },
    downloadXLSX() {
      const params = this.getParms()
      this.working.wLoading = true
      this.$store
        .dispatch('reports/getStudentsOutingsXlsx', params)
        .then((response) => {
          _downloadFileFromContentDisposition({ response })
          this.toast.success = true
        })
        .catch((e) => {
          console.log(e)
          this.toast.failed = true
        })
        .finally(() => {
          this.working.wLoading = false
        })
    },
    getEntries() {
      var self = this
      this.callApi(function (items) {
        self.entries = items
      })
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.callApi()
    },
    //Datos
    callApi(
      callback = () => {},
      ignorePagination,
      isInitialStateParams = false
    ) {
      const offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
      const params = {
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
      }

      if (!ignorePagination) {
        params.page = this.pagination.rowsPerPage
        params.offset = offset
      }

      if (this.timeFirst) {
        params.from = this.timeFirst
      }
      if (this.timeLast) {
        params.to = this.timeLast
      }

      if (isNotEmpty(this.filters.levelIds)) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }
      if (isNotEmpty(this.filters.gradeGroupIds)) {
        params.gradeGroupIds = this.filters.gradeGroupIds.map((e) => e.groupId)
      }
      if (isNotEmpty(this.filters.requestType)) {
        if (!(this.requestType.length === this.filters.requestType.length)) {
          params.requestType = this.filters.requestType.map((e) => e.value)
        }
      }
      if (this.filters.search) {
        params.search = this.filters.search
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)
      this.showFilter = _isSomeDifferent(
        structuredClone(this.initialStateParams),
        tempParams
      )

      this.working.wEntries = true
      this.$store
        .dispatch('reports/getStudentsOutingsReport', {
          ...params,
          search: this.search.trim() === '' ? undefined : this.search,
        })
        .then((response) => {
          this.working.wEntries = false
          this.json_data = Object.assign(response.data.items)
          // console.log(this.json_data)
          this.entries = response.data.items
          callback(response.data.items)
          this.createEntriesCSV()
        })
        .catch((error) => {
          console.log('temp')
          this.toast.failed = true
          this.working.wEntries = false
          console.log(error)
        })
    },
    _moment(time, tz, format) {
      return moment(time).tz(tz).format(format)
    },
    _momentP(time, format) {
      return moment(new Date(time)).format(format)
    },
    createEntriesCSV() {
      const format = 'DD/MM/YYYY HH:mm:ss'
      for (let index = 0; index < this.json_data.length; index++) {
        const el = this.json_data[index]

        if (el.requestedTime != null) {
          // this.json_data[index].createdAt = this._moment(
          //   new Date(this.json_data[index].requestedTime),
          //   this.getBrandTZ.timezone,
          //   'DD/MM/YYYY HH:mm:ss'
          // )
          el.requestedTime = this._momentP(el.requestedTime, format)
        } else {
          el.requestedTime = '-'
        }

        if (el.calledTime != null) {
          // this.json_data[index].calledTime = this._moment(
          //   new Date(this.json_data[index].calledTime),
          //   this.getBrandTZ.timezone,
          //   'DD/MM/YYYY HH:mm:ss'
          // )
          el.calledTime = this._momentP(el.calledTime, format)
        } else {
          el.calledTime = '-'
        }

        if (el.deliveryTime != null) {
          // this.json_data[index].deliveryTime = this._moment(
          //   new Date(this.json_data[index].deliveryTime),
          //   this.getBrandTZ.timezone,
          //   'DD/MM/YYYY HH:mm:ss'
          // )
          el.deliveryTime = this._momentP(el.deliveryTime, format)
        } else {
          el.deliveryTime = '-'
        }

        if (el.cancelledTime != null) {
          // this.json_data[index].cancelledTime = this._moment(
          //   new Date(this.json_data[index].cancelledTime),
          //   this.getBrandTZ.timezone,
          //   'DD/MM/YYYY HH:mm:ss'
          // )
          el.cancelledTime = this._momentP(el.cancelledTime, format)
        } else {
          el.cancelledTime = '-'
        }

        if (this.json_data[index].typeReq == 'PAR') {
          this.json_data[index].typeReq = 'Tutor'
        } else if (this.json_data[index].typeReq == 'QRT') {
          this.json_data[index].typeReq = 'Tercero'
        } else if (this.json_data[index].typeReq == 'EMP') {
          this.json_data[index].typeReq = 'Staff'
        }
        if (this.json_data[index].carModel == null) {
          this.json_data[index].carModel = 'Caminando'
          this.json_data[index].carColor = 'N/A'
          this.json_data[index].plates = 'N/A'
        }
        if (this.json_data[index].parentLastName == '') {
          this.json_data[index].parentLastName = ''
        }
      }
    },
    _resetLevels() {
      this.levels = this.posibleFilters.levels
      this.filters.levelIds = ''
    },
    _resetGrades() {
      this.grades = this.posibleFilters.gradeGroups
      this.filters.gradeGroupIds = ''
    },
    filterLevel() {
      if (this.filters.levelIds.length === 0) {
        this._resetGrades()
        this._resetLevels()
        return
      }

      const groups = filterByLevel({
        levelIds: this.filters.levelIds.map((e) => e.levelId),
        posibleGroups: this.posibleFilters.gradeGroups,
      })
      this.grades = groups
    },
    filterClear() {
      this._resetLevels()
      this._resetGrades()
      this.pagination.sortBy = 'NAME'
      this.pagination.descending = false
      this.showFilters = false
      this.search = ''
      this.filters.search = ''
      this.filters.requestType = [
        { text: 'Tutor', value: 'PAR' },
        { text: 'Tercero', value: 'QRT' },
        { text: 'Staff', value: 'EMP' },
        { text: 'Pase de salida', value: 'EXT' },
        { text: 'Transporte', value: 'STR' },
      ]
      this.timeFirst = moment().format('YYYY-MM-DD')
      this.timeLast = moment().format('YYYY-MM-DD')
      this.entries = []
      this.gradeGroup = {}
      this.level = {}
      this.grades = this.posibleFilters.gradeGroups
      this.levels = this.posibleFilters.levels
      // this.getLevels()
      // this.getEntries()
    },
    getRoomID(idBranch) {
      return idBranch + '-deliveries'
    },
    subscribeWs() {
      if (!this.connected && this.getBranch && this.getBranch.id) {
        var room = this.getRoomID(this.getBranch.id)
        // console.log('Connecting & subscribing to ', room)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.connected = true
      } else {
        console.log('No branch yet')
      }
    },
    async _getGradeGroupsLevels() {
      const { data } = await this.$store.dispatch('reports/getFilters')

      const levels = parseLevels({ levels: data })
      const groups = parseGroups({ gradeGroups: data })
      this.grades = groups
      this.levels = levels
      this.posibleFilters.levels = levels
      this.posibleFilters.gradeGroups = groups
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllItems) {
          this.filters.requestType = []
        } else {
          this.filters.requestType = this.requestType.slice()
        }
        this.getCollegeAuthorizations()
      })
    },
  },
  mounted() {
    this.callApi(null, false, true)
    this.getEntries()
    this._getGradeGroupsLevels()
    this.subscribeWs()
  },
  beforeDestroy() {
    var room = this.getRoomID(this.getBranch.id)
    // console.log('Unsubscribe from', room)
    this.$socket.emit('unsubscribe', room)
  },

  //Socket para datos
  sockets: {
    connect(evt) {
      // console.log('Connected', evt)
    },
    disconnect(evt) {
      // console.log('Disconnected', evt)
    },
    reconnect() {
      // console.log('Reconnected')
      this.subscribeWs()
    },

    message(notification) {
      var filterLevelId = (this.level || {}).id
      if (filterLevelId && filterLevelId !== notification.idLevel) {
        return
      }

      var filterGradeGroupId = (this.gradeGroup || {}).id
      if (
        filterGradeGroupId &&
        filterGradeGroupId !== notification.idGradeGroup
      ) {
        return
      }

      var from = this.timeFirst
          ? moment(this.timeFirst, 'YYYY-MM-DD')
              .hour(0)
              .minute(0)
              .second(0)
              .millisecond(0)
          : undefined,
        to = this.timeLast
          ? moment(this.timeLast, 'YYYY-MM-DD')
              .hour(23)
              .minute(59)
              .second(59)
              .millisecond(999)
          : undefined,
        createdAt = moment(new Date(notification.createdAt)).format(
          'DD/MM/YYYY HH:mm:ss'
        )

      if (from && from.isAfter(createdAt)) {
        return
      }

      if (to && to.isBefore(createdAt)) {
        return
      }

      if (this.filters.search) {
        var pattern = '^.*' + this.filters.search + '.*'
        var regex = RegExp(pattern, 'i')
        if (
          !regex.test(notification.firstName) &&
          !regex.test(notification.lastName)
        ) {
          return
        }
      }

      //------------------- Cancel -------------------------------
      if (notification.status == 'X') {
        let index = this.entries.findIndex(
          (entry) => entry.id == notification.id
        )
        if (index >= 0) {
          let objaux = this.entries[index]
          objaux.cancelledTime = moment(
            new Date(notification.cancelledTime)
          ).format('DD/MM/YYYY HH:mm:ss')
          this.entries.splice(index, 1, objaux)
          return
        } else {
          notification.cancelledTime = moment(
            new Date(notification.cancelledTime)
          ).format('DD/MM/YYYY HH:mm:ss')
        }
      }
      //------------------- Called -------------------------------
      if (notification.status == 'C') {
        let index = this.entries.findIndex(
          (entry) => entry.id == notification.id
        )
        let objaux = this.entries[index]
        objaux.calledTime = moment(new Date(notification.calledTime)).format(
          'DD/MM/YYYY HH:mm:ss'
        )
        this.entries.splice(index, 1, objaux)
        return
      }
      //------------------- Deliver -------------------------------
      if (notification.status == 'D') {
        let index = this.entries.findIndex(
          (entry) => entry.id == notification.id
        )
        if (index >= 0) {
          let objaux = this.entries[index]
          objaux.deliveryTime = moment(
            new Date(notification.deliveryTime)
          ).format('DD/MM/YYYY HH:mm:ss')
          this.entries.splice(index, 1, objaux)
          return
        } else {
          notification.deliveryTime = moment(
            new Date(notification.deliveryTime)
          ).format('DD/MM/YYYY HH:mm:ss')
        }
      }

      // Ajustar el objeto del socket
      notification.level = notification.student.level.typeLevel
      notification.firstName = notification.student.firstName
      notification.lastName = notification.student.lastName
      notification.grade =
        notification.student.gg.grade + notification.student.gg.group
      notification.personId = notification.student.personId
      notification.parentName = notification.parent.firstName
      notification.parentLastName = notification.parent.lastName
      notification.door = notification.door.doorName
      notification.typeUser = notification.typeUser

      if (notification.typeReq == 'PAR') {
        notification.typeReq = 'Tutor'
      } else if (notification.typeReq == 'QRT') {
        notification.typeReq = 'Tercero'
      } else if (notification.typeReq == 'STR') {
        notification.typeReq = 'Chofer'
      } else if (notification.typeReq == 'EMP') {
        notification.typeReq = 'Staff'
        notification.parentName = 'Solicitado por Staff'
        notification.parentLastName = ''
      }

      if (notification.car) {
        notification.carModel = notification.car.model
        notification.carColor = notification.car.color
        notification.plates = notification.car.plates
      }

      const format = 'DD/MM/YYYY HH:mm:ss'
      notification.requestedTime = this._momentP(
        notification.requestedTime,
        format
      )

      if (this.entries) {
        notification.isNew = true
        this.entries.unshift(notification)
      } else {
        this.entries = [notification]
      }

      var self = this
      setTimeout(function () {
        var item = self.entries.find(function (el) {
          return el.id === notification.id
        })

        if (item) {
          item.isNew = false
        }
      }, 2000)
    },
  },

  watch: {
    getUser() {
      if (this.entries.length <= 0) {
        this.getEntries()
      }
    },
    getBranch() {
      this.subscribeWs()
    },
    timeFirst() {
      this.getEntries()
    },
    timeLast() {
      this.getEntries()
    },
    gradeGroup() {
      this.getEntries()
    },
    // filters: {
    //   handler() {
    //     this.getEntries()
    //   },
    //   deep: true,
    // },
  },

  //Fecha de inicio y fecha final predeterminada
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    selectAllItems() {
      return this.filters.requestType.length === this.requestType.length
    },
    selectSomeItems() {
      return this.filters.requestType.length > 0 && !this.selectAllItems
    },
    icon() {
      if (this.selectAllItems) return 'disabled_by_default'
      if (this.selectSomeItems) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
    ...mapGetters(['getUser', 'getBranch', 'getBrandTZ']),
  },
}
</script>

<style>
.main-tool-bar {
  z-index: 1;
}

.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.new-entry {
  animation: difuminar 3s 1;
}

@keyframes difuminar {
  0% {
    background-color: rgba(143, 188, 143, 1);
  }
  100% {
    background-color: rgba(143, 188, 143, 0);
  }
}
</style>
<style scoped>
.sortable_pick {
  cursor: pointer;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.icon-select {
  padding: 8px;
}
.table-full .v-datatable.v-table > tbody {
  max-height: calc(102vh - 426px);
  min-height: calc(102vh - 426px);
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}
::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}
</style>
